import { render, staticRenderFns } from "./ContentViewSettingsPosition.vue?vue&type=template&id=17aaf84a&"
import script from "./ContentViewSettingsPosition.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports